import API from "./baseService";

export const subscribeToNewsletterResults = (params) => (
  API.post("/newsletter", { ...params })
)